
import { useEffect, useState } from "react";
import { RepositionCardProduct } from "./RepositionCardProduct.component";
import { CardRedencion } from "../../CardProducto/cardRedencion.component";
import { useDispatch, useSelector } from "react-redux";
import { setCarritoPromos } from "../../../Redux/actions/CarritoPromoAction";


export const Reposition = ({ carrito = [], history }) => {

    let carritoPromosRedux = useSelector(state => state.carritoPromo.carritoPromos);
    // let _carritoPromos = JSON.parse(localStorage.getItem('carritoPromos' ahora llamamos al constant)) || {};
    const dispatchPromo = useDispatch();

    const AgregarCarritoPromos = carritoPromos => dispatchPromo(setCarritoPromos(carritoPromos));

    const [productos, setProductos] = useState([]);
    let redenciones = Object.keys(carritoPromosRedux);

    // useEffect(() => {
    //     setRedenciones(Object.keys(carritoPromosRedux))
    // }, [carritoPromosRedux])
    //______Consulta__________
    const getProductos = () => {
        let subKeys = [];

        redenciones.map(
            key => {
                carritoPromosRedux[key].seleccionados
                    .map(
                        (ps, i) => {
                            const search = subKeys.find(sk => sk.codigoSkuPromocion == ps.codigoSkuPromocion);

                            if (search) {
                                const aux = search.cantidadTotal + ps.cantidad;
                                search.cantidadTotal = aux;

                                subKeys[search.posicion] = search;
                            } else {
                                subKeys.push({
                                    key: key,
                                    posicion: i,
                                    nombre: ps.nombre,
                                    codigoSkuPromocion: ps.codigoSkuPromocion,
                                    cantidadTotal: ps.cantidad,
                                    tipoIntegracion: ps.tipoIntegracion,
                                    codigoPromocion: ps.codigoPromocion,
                                    unidadesxCaja: ps.unidadesxCaja,
                                })
                            }
                        }
                    )
            }
        )

        setProductos(subKeys);
    }

    const handleDeleteToCart = (producto) => {

        const keys = Object.keys(carritoPromosRedux);

        keys.map(
            key => {
                let filteredSelectedProducts = [];
                let suma = 0;

                if (producto.tipoIntegracion == 1) {
                    filteredSelectedProducts = carritoPromosRedux[key].seleccionados.filter(
                        se =>
                            se.codigoPromocion != producto.codigoPromocion
                    );

                } else {
                    filteredSelectedProducts = carritoPromosRedux[key].seleccionados.filter(
                        se => se.codigoSkuPromocion != producto.codigoSkuPromocion
                    );
                    filteredSelectedProducts.map(se => suma += se.cantidad);
                }

                
                carritoPromosRedux[key]['seleccionados'] = filteredSelectedProducts;
                carritoPromosRedux[key]['cantidadReclamada'] = suma;
                AgregarCarritoPromos(carritoPromosRedux);
            }
        );
        getProductos();
    }

    useEffect(() => {
        getProductos();
    }, [carritoPromosRedux])

    return (
        <div className={"grid-reposition "}>
            <div className={"grid-reposition-obtained scrollSlider " + (productos.length > 0 ? "" : "hide")}>
                {
                    productos.map(
                        (p, i) => {
                            return (
                                <RepositionCardProduct
                                    producto={p}
                                    handleDeleteToCart={handleDeleteToCart}
                                    updateProductSummary={getProductos}
                                    key={i + "" + p.nombre}
                                />
                            )
                        }
                    )
                }
            </div>
            {/*<div className="grid-reposition-missing overflow-auto scrollSlider">
                {
                    Object.keys(carritoPromosRedux).map(
                        (re, i) => {
                            return (
                                carritoPromosRedux[re]
                                    ?
                                    <CardRedencion
                                        key={carritoPromosRedux[re].codigoSku + "" + i}
                                        redencion={carritoPromosRedux[re]}
                                        history={history}
                                        getProductos={getProductos}
                                        AgregarCarritoPromos={AgregarCarritoPromos}
                                    />
                                    :
                                    <></>
                            )
                        }
                    )
                }
            </div>*/}
        </div>
    )
}
